import { Envelope as Mail, MapPin } from '../ui/icons';
import { FaWhatsapp } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { useSettings } from '../../store/settingsStore';
import Logo from '../ui/Logo';
import BrandMark from '../ui/BrandMark';

export default function Footer() {
  const { t, toggleLanguage, language, canSwitchLanguage } = useI18n();
  const { whatsappNumber } = useSettings();
  const whatsappMessage = encodeURIComponent('Hola, me interesa saber más sobre sus productos');

  return (
    <footer id="site-footer" className="glass mt-10 py-4 sm:mt-12 sm:py-5">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 text-left">
        <div className="shrink-0">
          <div className="flex items-center gap-2"><BrandMark className="h-7 w-7 sm:h-9 sm:w-9" /><Logo variant="wordmark" wordmarkClassName="h-6 w-auto object-contain sm:h-8" /></div>
          <p className="mt-2 hidden whitespace-nowrap text-xs text-muted lg:block">{t('footer_tagline')}</p>
        </div>

        <address className="flex flex-col items-end gap-1.5 text-[11px] not-italic text-muted sm:text-sm lg:flex-row lg:items-center lg:gap-4">
          <a href="mailto:info@tecnicelu.store" className="inline-flex items-center gap-2 transition-colors hover:text-brand">
            <Mail className="h-4 w-4 text-brand" />
            info@tecnicelu.store
          </a>
          <a href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-whatsapp" aria-label="Contactar por WhatsApp">
            <FaWhatsapp className="h-4 w-4 text-whatsapp" aria-hidden="true" />
            +{whatsappNumber}
          </a>
          <span className="inline-flex items-center gap-2">
            <MapPin className="h-4 w-4 text-accent" />
            Medellín, Colombia
            <span role="img" aria-label="Bandera de Colombia" className="colombia-flag" />
          </span>
        </address>
      </div>

      <p className="mx-auto mt-3 max-w-7xl border-t border-line px-4 pt-3 text-center text-[11px] text-subtle">
        &copy; {new Date().getFullYear()} TECNICELU S.A. {t('footer_rights')}
        <span className="mx-2">·</span>
        <Link to="/privacy" className="font-medium transition-colors hover:text-brand">{t('footer_privacy')}</Link>
        <span className="mx-2">·</span>
        <Link to="/terms" className="font-medium transition-colors hover:text-brand">{t('footer_terms')}</Link>
        {canSwitchLanguage && <><span className="mx-2">·</span><span className="inline-flex items-center gap-1 align-middle" role="group" aria-label="Language">
          {(['es', 'en'] as const).map((option) => <button key={option} onClick={() => { if (language !== option) toggleLanguage(); }} className={`rounded px-1 py-0.5 font-semibold transition-colors ${language === option ? 'text-brand' : 'text-subtle hover:text-brand'}`} aria-pressed={language === option}>{option.toUpperCase()}</button>)}
        </span></>}
      </p>

      <a
        href="https://www.youtube.com/@losrecomendados-co"
        target="_blank"
        rel="noreferrer"
        className="mx-auto mt-2 flex max-w-7xl items-center justify-center gap-1.5 px-4 text-[11px] text-subtle transition-colors hover:text-brand"
        aria-label={t('header_losrecomendados')}
        title={t('header_losrecomendados')}
      >
        {t('footer_made_with')} <img src="https://assets.tecnicelu.store/logos/losrecomendados-logo.png" alt="" className="h-4 w-4 rounded-full object-cover" />
      </a>
    </footer>
  );
}
